// extracted by mini-css-extract-plugin
module.exports = {"resultContainer":"ResultCard_resultContainer__2dtl3","description":"ResultCard_description__OTyiF","owner":"ResultCard_owner__3VHby","info":"ResultCard_info__2TM7q"};